export default __webpack_public_path__ + "static/messenger-9257950989db36e3b325f2e2189cdfa4.svg";